module.exports = __webpack_public_path__ + "img/grid_view.d30d93a1.svg";